{
    "BroadworksProvisioningHeader": "Provisionnement du Service Pack Broadworks",
    "BroadworksProvisioningTableHeaderEnabled": "Activé",
    "BroadworksProvisioningTableHeaderItem": "Article",
    "BroadworksProvisioningTableHeaderServicePack": "Service Pack",
    "BroadworksProvisioningTableHeaderTelephonyServers": "Serveur(s) de téléphonie",
    "BroadworksProvisioningAddEntry": "Ajouter une entrée...",
    "BroadworksProvisioningItemExtension": "Extension",
    "BroadworksProvisioningItemHospitality": "Hospitalité",
    "BroadworksProvisioningItemAcdAgent": "Agent ACD",
    "BroadworksProvisioningButtonDiscardChanges": "Changements dans les rejets",
    "BroadworksProvisioningButtonSave": "Sauvez",
    "BroadworksProvisioningButtonActions": "Actions",
    "BroadworksProvisioningButtonDelete": "Supprimer",
    "BroadworksProvisioningButtonEdit": "Modifier",
    "BroadworksProvisioningValueIsRequired": "La valeur est requise.",
    "NAME": "Provisioning",
    "BroadworksProvisioningTableHeaderSendWelcomeEmail": "Envoyer un courriel de bienvenue",
    "BroadworksProvisioningItemEssentials": "L'essentiel",
    "BroadworksProvisioningItemProfessional": "Professionnel",
    "BroadworksProvisioningItemCallCentreAgent": "Agent du centre d'appel",
    "BroadworksProvisioningItemEnterprise": "Entreprise",
    "BroadworksProvisioningItemCallCentreSupervisor": "Superviseur du centre d'appels",
    "BroadworksProvisioningItem1000": "Akixi 1000",
    "BroadworksProvisioningItem2000": "Akixi 2000"
}